import { render, staticRenderFns } from "./HostPolicyPill.vue?vue&type=template&id=17b2a826&scoped=true&"
import script from "./HostPolicyPill.vue?vue&type=script&lang=js&"
export * from "./HostPolicyPill.vue?vue&type=script&lang=js&"
import style0 from "./HostPolicyPill.vue?vue&type=style&index=0&id=17b2a826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2a826",
  null
  
)

export default component.exports